module.exports = __webpack_public_path__ + "static/media/AshevilleBrewingpostcardstylepaintedmural.0499610f.webp";